import {Dialog} from '@material-ui/core'
import Button from '@material-ui/core/Button'
import {makeStyles} from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import * as storage from 'api/storageApi'
import {updateUserNoticeDismissApi} from 'api/userNoticeApi'
import Card from 'components/atoms/Card'
import {styles} from 'components/Dialog/SuccessDialog'
import useFailureModal from 'features/modal/useFailureModal'
import {
  closeUserNotice,
  selectCurrentUserNotice,
} from 'features/modal/userNoticeSlice'
import {useAppDispatch, useAppSelector} from 'hooks'
import React from 'react'
import {useTranslation} from 'react-i18next'

const useStyles = makeStyles(styles)

const UserNoticeReadDialog = () => {
  const classes = useStyles()
  const {t} = useTranslation()
  const dispatch = useAppDispatch()
  const {onOpen: onFailureModalOpen} = useFailureModal()
  const notice = useAppSelector(selectCurrentUserNotice)

  const handleClose = () => dispatch(closeUserNotice())

  const handleHideForWeek = () => {
    if (notice) storage.hideUserNoticeForWeek(notice.noticeId)
    handleClose()
  }

  const handleDismiss = async () => {
    if (!notice) return
    try {
      await updateUserNoticeDismissApi(notice.noticeId)
    } catch (err) {
      onFailureModalOpen(err.message)
    }
    handleClose()
  }

  return (
    <Dialog open={!!notice} disableEscapeKeyDown className={classes.root}>
      <Card className={classes.alertRoot}>
        <div>
          {/* 버튼 문구가 줄바꿈되지 않도록 기본(450)보다 넓게 */}
          <div className={classes.alertContainer} style={{width: 540}}>
            <h2>{notice?.title}</h2>
            <Typography
              variant='h6'
              style={{
                whiteSpace: 'pre-line',
                textAlign: 'left',
                alignSelf: 'stretch',
              }}
            >
              {notice?.content}
            </Typography>
          </div>

          <div
            className={classes.alertButtonContainer}
            style={{display: 'flex', flexWrap: 'nowrap', gap: 10}}
          >
            <Button
              variant='contained'
              color='default'
              disableElevation
              onClick={handleHideForWeek}
              style={{color: '#555555', whiteSpace: 'nowrap'}}
            >
              {t('IHideForWeek')}
            </Button>
            <Button
              variant='contained'
              color='default'
              disableElevation
              onClick={handleDismiss}
              style={{color: '#555555', whiteSpace: 'nowrap'}}
            >
              {t('IOffNotification')}
            </Button>
            <Button
              variant='contained'
              color='primary'
              disableElevation
              onClick={handleClose}
              style={{whiteSpace: 'nowrap'}}
            >
              {t('IOk')}
            </Button>
          </div>
        </div>
      </Card>
    </Dialog>
  )
}

export default UserNoticeReadDialog
